import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const ScrollHint = ({ targetId, label, dark }) => {
  const handleClick = () => {
    const el = document.getElementById(targetId);
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.button
      onClick={handleClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.2 }}
      className="group flex flex-col items-center gap-1.5 mx-auto cursor-pointer py-4"
      data-testid={`scroll-hint-${targetId}`}
      aria-label={label || 'Scroll down'}
    >
      {label && (
        <span className={`text-2xs font-semibold tracking-[0.2em] uppercase group-hover:text-taxera-teal transition-colors ${dark ? 'text-slate-500' : 'text-slate-400'}`}>
          {label}
        </span>
      )}
      <motion.div
        animate={{ y: [0, 6, 0] }}
        transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
      >
        <ChevronDown className={`w-5 h-5 group-hover:text-taxera-teal transition-colors ${dark ? 'text-slate-500' : 'text-slate-300'}`} strokeWidth={1.5} />
      </motion.div>
    </motion.button>
  );
};

export default ScrollHint;
